import {
  Box,
  Grid,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import styles from "../InternalTracker.module.css";
import RootComponents from "../../../components/common/RootComponents";
import {
  convertArrayToString,
  customTextColor,
  formatDate,
  formatTime,
  whichStatus,
} from "../../../utils/const";
import { useEffect, useState } from "react";
import { IoIosAdd } from "react-icons/io";
import { IoIosArrowRoundBack } from "react-icons/io";
import { CiMobile3 } from "react-icons/ci";
import { PiMailboxLight } from "react-icons/pi";
import { useLocation, useNavigate } from "react-router-dom";
import RequirementsJobList from "../../../components/common/RequirementsJobList";
import { getOneSubmissionTracker } from "../../../redux/internal-tracking/InternalSubmissionSlice";
import { useDispatch, useSelector } from "react-redux";
import { resetStatus } from "../../../redux/auth/authSlice";
import { BsThreeDotsVertical } from "react-icons/bs";
import Resume from "../../../assets/images/Resume - Profile.png";
import { RiDeleteBinLine } from "react-icons/ri";
import { chnageStatusOfCandidate } from "../../../redux/post-requirement/postRequirementSlice";
import { allLocation } from "../../../redux/common/locationSlice";
import { allWorkAuthorization } from "../../../redux/common/workAuthorizationSlice";
import InterviewStatusdrawer from "./InterviewStatusDrawer";
import { PiBuildingLight, PiUserLight } from "react-icons/pi";

const statusList = [
  { key: "INTERNAL_SUBMISSION", label: "Submitted" },
  { key: "ECI_SUBMISSION", label: "Eci Submission" },
  { key: "EC_SUBMISSION", label: "Ec Submission" },
  { key: "1st_ROUND_OF_INTERVIEW", label: "1st round intro" },
  { key: "2nd_ROUND_OF_INTERVIEW", label: "2nd round intro" },
  { key: "3rd_ROUND_OF_INTERVIEW", label: "3rd round intro" },
  { key: "OFFER_CONFIRMATION", label: "Offer Confirmation" },
  { key: "REJECTED", label: "Rejected" },
];

const InternalTrackerView = () => {
  const [viewData, setViewData] = useState();
  const [open, setOpen] = useState(false);
  const [btn1, setBtn1] = useState(""); // Initial text for btn1
  const [isProfileVisible, setIsProfileVisible] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const handleCloseShowStatus = () => setShowStatus(false);
  const handleShowStatus = () => setShowStatus(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { row } = location.state || {};
  const { res } = location.state || {};
  const { index } = location.state || {};
  const viewdata = useSelector((state) => state.trackersubmission.trackerData);
  const trackerStatus = useSelector((state) => state.trackersubmission.status);
  const skillData = useSelector((state) => state.skill.data);
  const locations = useSelector((state) => state.location);
  const workautho = useSelector((state) => state.workautho);
  const profile = useSelector((state) => state.profile.data);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const requirementStatus = useSelector(
    (state) => state.postrequirement.status
  );

  const oneSubmisionStatus = useSelector(
    (state) => state.trackersubmission.oneSubmisionStatus
  );

  const [data, setData] = useState(
    location.state ||
      JSON.parse(localStorage.getItem("internalSubmissionCandidateDetails"))
  );

  useEffect(() => {
    if (location.state) {
      localStorage.setItem(
        "internalSubmissionCandidateDetails",
        JSON.stringify(location.state)
      );
      setData(location.state);
    }
  }, [location.state]);

  useEffect(() => {
    if (data) {
      let id = data?.row?.requirement_id;
      dispatch(getOneSubmissionTracker(id));
    }
  }, [data]);


  useEffect(() => {
    setViewData(viewdata?.requirements);
  }, [viewdata]);


  useEffect(() => {
    if (trackerStatus === "add_candidate_to_submission") {
      let id = data?.row?.requirement_id;
      dispatch(getOneSubmissionTracker(id));
    }
  }, [trackerStatus, data]);

  useEffect(() => {
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, []);

  const getSkillNames = (skills) => {
    return skills
      ?.map(
        (id) => skillData?.locations?.find((skill) => skill.id === id)?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join("  , "); // Join names with a comma and space
  };

  const handleThreeDotsClick = () => {
    setIsProfileVisible(!isProfileVisible);
  };
  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };
  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };

  // Function to handle dropdown item click
  const handleSelect = (text) => {
    setBtn1(text); // Update btn1 text
    handleClickOpen();
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOnClickStatusChange = () => {
    let userData = {
      candidate_status: btn1,
      requirement_candidate_tracker: data?.res?.id,
    };
    let id = data?.res?.id;
    dispatch(chnageStatusOfCandidate({ userData, id }));
  };

  useEffect(() => {
    if (requirementStatus === "change_candidate_status") {
      let id = viewData?.requirement_id;
      dispatch(getOneSubmissionTracker(id));
      handleClose();
    }
  }, [requirementStatus]);

  useEffect(() => {
    setBtn1(data?.res?.progress[0]?.candidate_status);
  }, [res]);

  const getSelectedIndex = () =>
    statusList.findIndex((item) => item.key === btn1);

  return (
    // <RootComponents>
    <>
      {oneSubmisionStatus === "loading" ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 230,
          }}
        >
          <CircularProgress size={30} color="info" />
        </Box>
      ) : (
        <Box className={styles.add_structure}>
          <Grid
            container
            className={styles.verification_phase}
            sx={{ backgroundColor: "#fff" }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              sx={{ color: customTextColor, border: "none !important" }}
            >
              <Typography sx={{ marginLeft: "0 !important" }}>
                Track on:{" "}
                <b>
                  {viewData?.created_at !== undefined &&
                    formatDate(viewData?.created_at)}
                  {", "}
                  {viewData?.created_at !== undefined &&
                    formatTime(viewData?.created_at)}
                </b>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              sx={{ color: customTextColor }}
            >
              <Typography>
                Internal Submission:{" "}
                <b> {viewData?.status_counts?.internal_submission}</b>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              sx={{ color: customTextColor }}
            >
              <Typography>
                Client Submission:{" "}
                <b> {viewData?.status_counts?.client_submission}</b>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              sx={{ color: customTextColor }}
            >
              <Typography>
                Interview: <b>{viewData?.status_counts?.internal_submission}</b>
              </Typography>
            </Grid>
            {/* <Grid
              item
              xs={12}
              sm={12}
              md={0.4}
              lg={0.4}
              sx={{ color: customTextColor }}
            >
              <BsThreeDotsVertical
                onClick={handleThreeDotsClick}
                style={{
                  cursor: "pointer",
                  fontSize: "20px",
                  marginLeft: "15px",
                }}
              />
            </Grid> */}
          </Grid>
          {/* {isProfileVisible && ( */}
          <Grid
            container
            className={styles.candidates_name}
            sx={{ marginBottom: "14px" }}
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Grid
                container
                className={styles.requirement_details_view}
                sx={{ color: customTextColor }}
              >
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <span>
                    <Box>
                      <PiUserLight
                        style={{ fontSize: "25px", color: customTextColor }}
                      />
                      <Typography>
                        Received from: <b>{viewData?.bdm_name}</b>
                      </Typography>
                    </Box>
                    <Box sx={{ marginBottom: "0 !important" }}>
                      <PiMailboxLight
                        style={{ fontSize: "25px", color: customTextColor }}
                      />
                      <Typography>
                        Work Email ID : <b>{viewData?.bdm_email}</b>
                      </Typography>
                    </Box>
                  </span>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <span>
                    <Box>
                      <PiBuildingLight
                        style={{ fontSize: "25px", color: customTextColor }}
                      />
                      <Typography>
                        Company Name: <b>{viewData?.company_name}</b>
                      </Typography>
                    </Box>

                    <Box sx={{ marginBottom: "0 !important" }}>
                      <CiMobile3
                        style={{ fontSize: "25px", color: customTextColor }}
                      />
                      <Typography>
                        Phone No: <b>{viewData?.bdm_mobile_no}</b>
                      </Typography>
                    </Box>
                  </span>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* )} */}
          <Box className={styles.profile_submit}>
            <Box>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>
                  <Typography sx={{ marginTop: "10px !important" }}>
                    <b>
                      {viewData?.requirement_id}, {viewData?.job_title} with{" "}
                      {viewData?.experience} Years’ Experience at
                      {getLocationById(viewData?.location)},{" "}
                    </b>
                  </Typography>
                  <Typography>
                    <b>
                      {viewData?.duration} {viewData?.duration ? "Month" : ""}{" "}
                      {viewData?.job_type}
                    </b>
                  </Typography>
                  <Typography>
                    <b>
                      {" "}
                      From ${viewData?.rate}
                      {viewData?.requirement_type?.includes("full_Time")
                        ? "K Yearly"
                        : " Hourly"}{" "}
                    </b>
                  </Typography>
                  <Typography>
                    <b> {viewData?.mode_of_interview} Interview</b>
                  </Typography>
                </span>

                <span
                  className={styles.phase2}
                  style={{ marginTop: "10px", alignSelf: "start" }}
                >
                  <Typography>
                    {data?.row?.created_at !== undefined &&
                      formatDate(data?.row?.created_at)}
                    {", "}
                    {data?.row?.created_at !== undefined &&
                      formatTime(data?.row?.created_at)}
                  </Typography>
                </span>
              </span>
            </Box>
          </Box>

          <Box className={styles.candidate_text}>
            {" "}
            <span>
              <Typography>
                <b>Job Description</b>
              </Typography>
              <Typography>
                {/* {viewData?.job_description} */}

                {viewData?.job_description?.split("\n")?.map(
                  (line, index) =>
                    line?.trim() && (
                      <p
                        key={index}
                        style={{ marginBottom: "2px", padding: "0" }}
                      >
                        {line}
                      </p>
                    )
                )}
              </Typography>
              <Typography>
                <b>Mandatory Skills</b>
              </Typography>
              <Typography>{getSkillNames(viewData?.skills)}</Typography>
            </span>
          </Box>

          <Box className={styles.consultant_details}>
            <span>
              <ul
                style={{
                  listStyleType: "square",
                  padding: "5px 20px",
                  lineHeight: "32px",
                }}
              >
                <Box>
                  <li>
                    <b>
                      {data?.res?.full_name}, {data?.res?.current_job_title}{" "}
                      (Exp {data?.res?.total_experience} Years)
                    </b>
                  </li>
                </Box>
                <Box>
                  <li>
                    <b>{getLocationById(data?.res?.current_location)}</b>
                  </li>
                </Box>
                <Box>
                  <li>
                    <b> {data?.res?.email}</b>
                  </li>
                </Box>
                <Box>
                  <li>
                    <b>{data?.res?.mobile_no}</b>
                  </li>
                </Box>
                <Box>
                  <li>
                    <b>
                      {getWorkAuthorization(data?.res?.work_authorization)},
                      Willing {data?.res?.work_preference}
                    </b>
                  </li>
                </Box>
                <Box>
                  <li>
                    <b>
                      {data?.res?.requirement_type?.includes("full_Time")
                        ? "Salary"
                        : "Rate"}{" "}
                      ${data?.res?.rate}
                      {data?.res?.requirement_type?.includes("full_Time")
                        ? "K Yearly"
                        : " Hourly"}{" "}
                      {/* on {data?.res?.prefer_tax_team} */}
                      {convertArrayToString(data?.res?.p_tax_team)}
                    </b>
                  </li>
                </Box>
              </ul>
            </span>
            <span style={{ textAlign: "center", marginTop: "30px" }}>
              {/* <Typography>Current Status</Typography> */}
              <Typography>
                <b>{data?.res?.progress?.[0]?.candidate_status}</b>
              </Typography>
              <a
                href={data?.res?.resume}
                target="_blank"
                style={{ textDecoration: "none", color: "#374151" }}
              >
                <img
                  src={Resume}
                  alt="attachment"
                  style={{
                    width: "70px",
                    marginTop: "15px",
                    cursor: "pointer",
                  }}
                />
                <Typography sx={{ marginTop: "10px" }}>
                  <b>Open Resume</b>
                </Typography>
              </a>
            </span>
          </Box>
          {profile?.profile?.role !== "BENCH_SALES_RECRUITER" &&
            (data?.res?.prefer_tax_team === "contract" ||
              data?.res?.prefer_tax_team === "contract_to_hire") && (
              <Grid
                container
                className={styles.requirement_view}
                sx={{ color: customTextColor }}
              >
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <span>
                    <Box>
                      <PiUserLight
                        style={{ fontSize: "25px", color: customTextColor }}
                      />
                      <Typography>
                        Employer Name: <b>{data?.res?.employer_manager_name}</b>
                      </Typography>
                    </Box>
                    <Box sx={{ marginBottom: "0 !important" }}>
                      <PiMailboxLight
                        style={{ fontSize: "25px", color: customTextColor }}
                      />
                      <Typography>
                        Work Email ID : <b>{data?.res?.employer_email} </b>
                      </Typography>
                    </Box>
                  </span>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <span>
                    <Box>
                      <PiUserLight
                        style={{ fontSize: "25px", color: customTextColor }}
                      />
                      <Typography>
                        Company Name: <b>{data?.res?.employer_company_name}</b>
                      </Typography>
                    </Box>

                    <Box sx={{ marginBottom: "0 !important" }}>
                      <CiMobile3
                        style={{ fontSize: "25px", color: customTextColor }}
                      />
                      <Typography>
                        Work Phone No: <b>{data?.res?.employer_mobile_no}</b>
                      </Typography>
                    </Box>
                  </span>
                </Grid>
              </Grid>
            )}

          <Box className={styles.add_candidate_btns}>
            <Box className={styles.add_back_btns}>
              <button
                // onClick={() => navigate("/internal-view")}
                onClick={() => {
                  navigate("/submision-tracker");

                  localStorage.setItem(
                    "internalSubmissionDetails",
                    JSON.stringify({ type: "view" })
                  );

                  localStorage.setItem(
                    "internalSubmissionDetailsWhichView",
                    JSON.stringify({ type: "view", row })
                  );
                }}
                style={{
                  border: "1.5px solid #4287f5",
                  marginRight: "10px",
                  padding: "4.5px 10px ",
                }}
              >
                <IoIosArrowRoundBack
                  style={{ fontSize: "25px", color: "#4287f5" }}
                />
              </button>
            </Box>
            <div className="btn-group">
              <button
                type="button"
                className="dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{
                  color: "black",
                  width: "7rem",
                  border: "1.5px solid #4287f5",
                  padding: "6px 10px",
                }}
              >
                {/* {whichStatus(btn1)} */}
                {statusList.find((item) => item.key === btn1)?.label ||
                  "Select Status"}
              </button>
              {/* <div className="dropdown-menu">
                <a
                  className="dropdown-item"
                  style={{ backgroundColor: "#fff" }}
                  onClick={() => handleSelect("INTERNAL_SUBMISSION")}
                >
                  Submitted
                </a>
                <a
                  className="dropdown-item"
                  style={{ backgroundColor: "#fff" }}
                  onClick={() => handleSelect("Eci Submission")}
                >
                  Eci Submission
                </a>
                <a
                  className="dropdown-item"
                  style={{ backgroundColor: "#fff" }}
                  onClick={() => handleSelect("Ec Submission")}
                >
                  Ec Submission
                </a>
                <a
                  className="dropdown-item"
                  style={{ backgroundColor: "#fff" }}
                  onClick={() => handleSelect("1st_ROUND_OF_INTERVIEW")}
                >
                  1st round intro
                </a>
                <a
                  className="dropdown-item"
                  style={{ backgroundColor: "#fff" }}
                  onClick={() => handleSelect("2nd_ROUND_OF_INTERVIEW")}
                >
                  2nd round intro
                </a>
                <a
                  className="dropdown-item"
                  style={{ backgroundColor: "#fff" }}
                  onClick={() => handleSelect("3rd_ROUND_OF_INTERVIEW")}
                >
                  3rd round intro
                </a>
                <a
                  className="dropdown-item"
                  style={{ backgroundColor: "#fff" }}
                  onClick={() => handleSelect("offer confirmation")}
                >
                  Offer Confirmation
                </a>
                <a
                  className="dropdown-item"
                  style={{ backgroundColor: "#fff" }}
                  onClick={() => handleSelect("Rejected")}
                >
                  Rejected
                </a>
              </div> */}

              <div className="dropdown-menu">
                {statusList.map((item, index) => (
                  <a
                    key={item.key}
                    className={`dropdown-item ${
                      index <= getSelectedIndex() ? styles.disabled : ""
                    }`}
                    onClick={() =>
                      index > getSelectedIndex() && handleSelect(item.key)
                    }
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>
          </Box>
        </Box>
      )}
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        maxWidth="md"
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <Box>
          <DialogTitle
            id="responsive-dialog-title"
            sx={{ textAlign: "center" }}
          >
            <b>Change Candidate Status </b>
          </DialogTitle>
          <DialogContent sx={{ textAlign: "center" }}>
            Are you sure you want to change status of{" "}
            <b> {data?.res?.full_name}</b> to
            <b> {btn1}</b>
          </DialogContent>
          <Box>
            <Box className={styles.adding_internal_btns}>
              <button
                sx={{ backgroundColor: "#2d73b5" }}
                onClick={handleOnClickStatusChange}
              >
                Yes
              </button>
              <button sx={{ backgroundColor: "#97B6F1" }}>No</button>
            </Box>
          </Box>
        </Box>
      </Dialog>
      <InterviewStatusdrawer
        handleShow={handleShowStatus}
        handleClose={handleCloseShowStatus}
        show={showStatus}
      />
    </>
    // </RootComponents>
  );
};

export default InternalTrackerView;
